import styled from 'styled-components';
import Theme from '@dagensmat/carrot/Theme';
import { MediaQuery } from 'utils/mediaQueries';

export const Table = styled.table`
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  tr {
    border-bottom: 1px solid ${Theme.Colours.lightGrey};
  }

  th,
  td {
    text-align: left;
    padding: ${Theme.Spacings.xs}px 0;
    word-break: break-word;
    vertical-align: top;

    :first-child {
      padding-right: ${Theme.Spacings.xxs}px;
    }

    :nth-child(2) {
      width: 30%;
    }

    ${MediaQuery.desktopUp} {
      :first-child {
        padding-left: ${Theme.Spacings.xs}px;
      }
      :last-child {
        padding-right: ${Theme.Spacings.xs}px;
      }

      :nth-child(2) {
        width: 12%;
      }
    }
  }

  thead {
    tr {
      th {
        color: ${Theme.Colours.secondary};
        text-transform: capitalize;
      }
    }
  }

  tbody {
    tr:hover {
      background-color: ${Theme.Colours.brightPurple};
    }
  }

  tfoot {
    td {
      vertical-align: top;
    }
  }
`;

export const ExpandedContent = styled.tr`
  :hover {
    background-color: ${Theme.Colours.white} !important;
  }

  td {
    padding-bottom: ${Theme.Spacings.m}px;
  }

  ${MediaQuery.desktopUp} {
    td:first-child {
      padding: ${Theme.Spacings.m}px;
    }
  }
`;

export const ClickActionIconContainer = styled.div`
  position: absolute;
  top: ${Theme.Spacings.xs}px;
  right: 0px;

  ${MediaQuery.desktopUp} {
    right: ${Theme.Spacings.xs}px;
  }

  ${MediaQuery.print} {
    display: none;
  }
`;
